import { useQuery } from '@tanstack/react-query';

import { getDatadogConfig } from '../instrumentation/getDatadogConfig';

export const useAppVersion = () => {
  const queryFn = async () => {
    const datadogConfig = await getDatadogConfig();

    return datadogConfig?.version ?? undefined;
  };

  return useQuery({
    queryKey: ['appVersion'],
    queryFn,
    staleTime: Infinity,
  });
};
